export const UserDeactivationDataLayerSymbol = Symbol.for("UserDeactivationDataLayerSymbol");
